import React, { useEffect, useState } from "react";
import axios from "axios";
import { BASE_URL } from "../../../config";
import defaulUser from "../../../assets/defaultUser.png"
import "../Styles/EstadisticasTorneo.css";

const EstadisticasPartidoComponent = ({ idPartido, idEquipo,   obtenerPartidos }) => {
  const [estadisticas, setEstadisticas] = useState([]);

  useEffect(() => {
  

    const obtenerEstadisticas = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}get-estadisticas-partido/${idPartido}/${idEquipo}` 
        );
        setEstadisticas(response.data);
      } catch (error) {
        console.error(error);
      }
    };
    

    obtenerEstadisticas();
  }, [idPartido, idEquipo]);


  const handleObservacionChange = async (id, observacion) => {
    try {
      await axios.put(`${BASE_URL}update-observacion/${id}`, { observacion });
    } catch (error) {
      console.error('Error al actualizar la observación:', error);
    }
  };

  const handlePuntosChange = async (id, puntos) => {
    try {
      await axios.put(`${BASE_URL}update-puntos/${id}`, { puntos });
      obtenerPartidos(); 
    } catch (error) {
      console.error('Error al actualizar los puntos:', error);
    }
  };


  const handleTarjetaAmarillaChange = async (id, value) => {
    try {
      await axios.put(`${BASE_URL}update-tarjeta-amarilla/${id}`, { tarjetaAmarilla: value });
     
      setEstadisticas((prevEstadisticas) =>
        prevEstadisticas.map((estadistica) =>
          estadistica.id === id ? { ...estadistica, tarjetaAmarilla: value } : estadistica
        )
      );
      obtenerPartidos(); 
    } catch (error) {
      console.error('Error al actualizar la tarjeta amarilla:', error);
    }
  };

  const handleTarjetaRojaChange = async (id, value) => {
    try {
      await axios.put(`${BASE_URL}update-tarjeta-roja/${id}`, { tarjetaRoja: value });
  
      setEstadisticas((prevEstadisticas) =>
        prevEstadisticas.map((estadistica) =>
          estadistica.id === id ? { ...estadistica, tarjetaRoja: value } : estadistica
        )
      );
      obtenerPartidos(); 
    } catch (error) {
      console.error('Error al actualizar la tarjeta roja:', error);
    }
  };


  const handleInputChange = (id, field, value) => {
    setEstadisticas((prevEstadisticas) =>
      prevEstadisticas.map((estadistica) =>
        estadistica.id === id ? { ...estadistica, [field]: value } : estadistica
      )
    );
  };

  return (
    <div className="container mt-4">
      <table className="table table-bordered mt-3">
        <thead>
          <tr>
          <th scope="col"></th>
            <th scope="col">Nombre</th>
            <th scope="col">Inicialista</th>
            <th scope="col">
              T.A
              <span className="tarjeta-amarela" />
            </th>
            <th scope="col">
              T.R
              <span className="tarjeta-roja" />
            </th>
            <th scope="col">Puntos</th>
            <th scope="col">Observación</th>
          </tr>
        </thead>
        <tbody>
          {estadisticas.map((estadistica) => (
            <tr key={estadistica.id}>
                <td>
                <img
                            src={estadistica.jugador.fotografiaPath || defaulUser} 
                            alt={`${estadistica.jugador.nombreJugador} Foto`}
                            className="goleador-foto"
                          />
              </td>
              <td>
                {estadistica.jugador.nombres} {estadistica.jugador.apellidos} #
                {estadistica.numeroCamiseta}
              </td>
              <td>{estadistica.inicialista ? 'Sí' : 'No'}</td>
              <td>
                <select
                  value={estadistica.tarjetaAmarilla}
                  onChange={(e) => handleTarjetaAmarillaChange(estadistica.id, e.target.value)}
                >
                  <option value="0">0</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                </select>
              </td>
              <td>
                <select
                  value={estadistica.tarjetaRoja}
                  onChange={(e) => handleTarjetaRojaChange(estadistica.id, e.target.value)}
                >
                  <option value="0">NO</option>
                  <option value="1">SI</option>
                </select>
              </td>
              <td>
                <input
                  type="number"
                  value={estadistica.puntos}
                  className="form-control"
                  style={{ width: '80px' }}
                  onChange={(e) => handleInputChange(estadistica.id, 'puntos', e.target.value)}
                  onBlur={(e) => handlePuntosChange(estadistica.id, e.target.value)}
                  min="0"
                />
              </td>
              <td>
                <input
                  type="text"
                  value={estadistica.observacion}
                  onChange={(e) => handleInputChange(estadistica.id, 'observacion', e.target.value)}
                  onBlur={(e) => handleObservacionChange(estadistica.id, e.target.value)}
                />
              </td>
            </tr>
          ))}
          {estadisticas.length === 0 && (
            <tr>
              <td colSpan="6" className="text-center">
                No hay estadísticas disponibles
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export { EstadisticasPartidoComponent };